export default __webpack_public_path__ + "static/grades1-c378acf00a2dcac40585a8c907f5b617.png";